import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  symbolList: [],  
  selectedSymbol: {},  
  interval: '',  
  startDate: '',  
  endDate: '',  
  dateRangeChanged: false, 
  pageLoaded: false,
  daysPreSet:0 
};

const entryPanelSlicer = createSlice({
  name: 'entryPanel',
  initialState,
  reducers: {
    setSymbolList: (state, action) => {
      state.symbolList = action.payload;
    },    
    setSelectedSymbol: (state, action) => {
      state.selectedSymbol = action.payload;
    },    
    setInterval: (state, action) => {
      state.interval = action.payload;
    },    
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },    
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },    
    setDateRangeChanged: (state, action) => {
      state.dateRangeChanged = action.payload;
    },
    setPageLoaded: (state, action) => {
      state.pageLoaded = action.payload;
    },
    setDaysPreSet: (state, action) => {
      state.daysPreSet = action.payload;
    }
  }
});

export const { setSymbolList, setSelectedSymbol, setInterval, setStartDate, setEndDate, setDateRangeChanged, setPageLoaded, setDaysPreSet } = entryPanelSlicer.actions;
export default entryPanelSlicer.reducer;